<template>
    <el-dialog :visible.sync="dialogVisible" title="訊息公告" @close="dialogOnClose()">
      <div v-for="item in dialogData" :key="item.waterNum" style="text-align:start; margin-left:40px;">
        <div v-if="item.status === 'Running'">
          水號[{{item.waterNum}}]智慧水表傳輸設備維護中。
        </div>
        <div v-if="!item.activated">
          水號[{{item.waterNum}}]智慧水表已中止用水。
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">
            確定
          </el-button>
        </div>
      </template>
    </el-dialog>
  </template>

  <script>

    export default {
        name: 'FanReplacementStatus',
        props: {
            show: {
                type: Boolean,
                default: false
            },
            data: {
                type: Array,
                default: () => []
            },
        },
        data() {
            return {
                dialogData: [],
                dialogVisible: false,
            }
        },
        watch: {
            show(newValue) {
                this.dialogVisible = newValue;
            },
            data(newVal) {
                this.dialogData = newVal
            }
        },
        computed: {

        },
        methods: {
          // Dialog關閉時觸發
          dialogOnClose() {
            this.dialogData = [] // 清空:Dialog Data
            this.dialogVisible = false 
            this.$emit('close')
        },
        }
    }
  </script>
